(function () {
  var root = document.querySelector('[data-pz-root]');
  if (!root) return;

  function wrapEvery15(text) {
    var words = text.split(' ');
    var lines = [];
    var current = '';
    words.forEach(function (word) {
      if (current === '') {
        current = word;
      } else if (lines.length >= 2) {
        current += ' ' + word;
      } else if ((current + ' ' + word).length <= 15) {
        current += ' ' + word;
      } else {
        lines.push(current);
        current = word;
      }
    });
    if (current) lines.push(current);
    return lines.join('\n');
  }


  var trigger = document.querySelector('[data-pz-trigger]');
  var overlay = document.querySelector('[data-pz-overlay]');
  var closeBtn = root.querySelector('[data-pz-close]');

  document.body.appendChild(overlay);
  document.body.appendChild(root);

  var lockedScrollY = 0;

  function getCurrentVariantId() {
    var form = document.querySelector('form[action*="/cart/add"]');
    var input = form && (form.querySelector('input[name="id"]') || form.querySelector('select[name="id"]'));
    return (input && input.value) || state.mainVariantId;
  }

  function syncVariant() {
    var freshId = getCurrentVariantId();
    if (!freshId || freshId === state.mainVariantId) return;
    state.mainVariantId = freshId;
    fetch(window.location.pathname + '.js')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var variant = data.variants.find(function (v) { return String(v.id) === String(freshId); });
        if (variant) {
          state.basePrice = variant.price / 100;
          updateTotal();
        }
      });
  }

  function openDrawer() {
    lockedScrollY = window.scrollY;
    syncVariant();
    root.style.visibility = 'visible';
    root.classList.add('is-open');
    overlay.classList.add('is-open');
    document.body.style.position = 'fixed';
    document.body.style.top = -lockedScrollY + 'px';
    document.body.style.width = '100%';
  }

  function closeDrawer() {
    root.classList.remove('is-open');
    overlay.classList.remove('is-open');
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    window.scrollTo(0, lockedScrollY);
    setTimeout(function () {
      root.style.visibility = 'hidden';
    }, 250);
  }

  trigger.addEventListener('click', openDrawer);
  closeBtn.addEventListener('click', closeDrawer);
  overlay.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  var state = {
    mainVariantId: root.dataset.mainVariantId,
    basePrice: parseFloat(root.dataset.basePrice),
    mainSide: 'Εξωτερική (φανερή)',
    priority: false,
    review: true,
    note: false,
    backEnabled: false,
    backType: null,
    backFont: 'Classic'
  };

  var addons = {
    innerText: { id: root.dataset.innerTextVariantId, price: parseFloat(root.dataset.innerTextPrice) },
    innerPhoto: { id: root.dataset.innerPhotoVariantId, price: parseFloat(root.dataset.innerPhotoPrice) },
    priority: { id: root.dataset.priorityVariantId, price: parseFloat(root.dataset.priorityPrice) },
    review: { id: root.dataset.reviewVariantId, price: parseFloat(root.dataset.reviewPrice) },
    note: { id: root.dataset.noteVariantId, price: parseFloat(root.dataset.notePrice) }
  };

  function formatMoney(amount) {
    return amount.toFixed(2).replace('.', ',') + '€';
  }

  var fileInput = root.querySelector('[data-pze-file]');
  var previewWrap = root.querySelector('[data-pze-preview]');
  var previewImg = root.querySelector('[data-pze-preview-img]');

  fileInput.addEventListener('change', function () {
    var file = fileInput.files[0];
    if (!file) {
      previewWrap.hidden = true;
      return;
    }
    previewImg.src = URL.createObjectURL(file);
    previewWrap.hidden = false;
  });

  var removeBtn = root.querySelector('[data-pze-remove]');
  removeBtn.addEventListener('click', function () {
    fileInput.value = '';
    previewWrap.hidden = true;
  });

  /* ---- Main side pill (Πλευρά Spotify Code) ---- */
  var beSubtitle = root.querySelector('[data-be-subtitle]');

  function otherSide(side) {
    return side === 'Εξωτερική (φανερή)' ? 'εσωτερική' : 'εξωτερική';
  }

  function updateBackSubtitle() {
    beSubtitle.textContent = 'Προσωπικό κείμενο ή φωτογραφία στην ' + otherSide(state.mainSide) + ' πλευρά';
  }

  var mainSideGroup = root.querySelector('[data-pz-pills="mainside"]');
  mainSideGroup.addEventListener('click', function (e) {
    var btn = e.target.closest('.pz__pill');
    if (!btn) return;
    mainSideGroup.querySelectorAll('.pz__pill').forEach(function (p) { p.classList.remove('is-active'); });
    btn.classList.add('is-active');
    state.mainSide = btn.dataset.value;
    updateBackSubtitle();
  });

  /* ---- Back engraving (Επιπλέον Χάραξη) ---- */
  var beToggle = root.querySelector('[data-be-toggle]');
  var beOptions = root.querySelector('[data-be-options]');
  var beOptionEls = Array.prototype.slice.call(root.querySelectorAll('[data-be-option]'));
  var beRadios = Array.prototype.slice.call(root.querySelectorAll('[data-be-radio]'));
  var beText = root.querySelector('[data-be-text]');
  var beCharcount = root.querySelector('[data-be-charcount]');
  var beFontPreview = root.querySelector('[data-be-font-preview]');
  var beFontBtns = Array.prototype.slice.call(root.querySelectorAll('[data-be-font]'));
  var beDropzone = root.querySelector('[data-be-dropzone]');
  var beFile = root.querySelector('[data-be-file]');
  var bePhotoPreviewWrap = root.querySelector('[data-be-photo-preview]');
  var bePhotoPreviewImg = root.querySelector('[data-be-photo-preview-img]');

  beToggle.addEventListener('change', function () {
    state.backEnabled = beToggle.checked;
    beOptions.hidden = !state.backEnabled;
    if (!state.backEnabled) {
      state.backType = null;
      beRadios.forEach(function (r) { r.checked = false; });
      beOptionEls.forEach(function (el) { el.classList.remove('is-selected'); });
      root.querySelector('[data-be-body="text"]').hidden = true;
      root.querySelector('[data-be-body="photo"]').hidden = true;
    }
    updateTotal();
  });

  beRadios.forEach(function (radio) {
    radio.addEventListener('change', function () {
      state.backType = radio.value;
      beOptionEls.forEach(function (el) {
        var selected = el.dataset.beOption === radio.value;
        el.classList.toggle('is-selected', selected);
        var body = el.querySelector('[data-be-body]');
        if (body) body.hidden = !selected;
      });
      updateTotal();
    });
  });

  beText.addEventListener('input', function () {
    beCharcount.textContent = beText.value.length + '/45';
    beFontPreview.textContent = wrapEvery15(beText.value.trim());
  });

  beFontBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      beFontBtns.forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
      state.backFont = btn.dataset.beFont;
      beFontPreview.style.fontFamily = btn.style.fontFamily;
    });
  });

  beDropzone.addEventListener('click', function () {
    beFile.click();
  });

  beFile.addEventListener('change', function () {
    var file = beFile.files[0];
    if (!file) {
      bePhotoPreviewWrap.hidden = true;
      return;
    }
    bePhotoPreviewImg.src = URL.createObjectURL(file);
    bePhotoPreviewWrap.hidden = false;
  });

  var bePhotoRemoveBtn = root.querySelector('[data-be-photo-remove]');
  bePhotoRemoveBtn.addEventListener('click', function () {
    beFile.value = '';
    bePhotoPreviewWrap.hidden = true;
  });

  var priorityToggle = root.querySelector('[data-pz-toggle="priority"]');
  priorityToggle.addEventListener('change', function () {
    state.priority = priorityToggle.checked;
    updateTotal();
  });

  var reviewToggle = root.querySelector('[data-pz-toggle="review"]');
  reviewToggle.addEventListener('change', function () {
    state.review = reviewToggle.checked;
    updateTotal();
  });

  var noteToggle = root.querySelector('[data-pz-toggle="note"]');
  noteToggle.addEventListener('change', function () {
    state.note = noteToggle.checked;
    updateTotal();
  });

  function updateTotal() {
    var total = state.basePrice;
    if (state.priority) total += addons.priority.price;
    if (state.review) total += addons.review.price;
    if (state.note) total += addons.note.price;
    if (state.backEnabled && state.backType === 'text') total += addons.innerText.price;
    if (state.backEnabled && state.backType === 'photo') total += addons.innerPhoto.price;
    root.querySelector('[data-pz-total]').textContent = formatMoney(total);
  }

  var errorEl = root.querySelector('[data-pz-error]');
  var submitBtn = root.querySelector('[data-pz-submit]');

  function showError(msg) {
    errorEl.textContent = msg;
    errorEl.hidden = false;
  }

  submitBtn.addEventListener('click', function () {
    errorEl.hidden = true;
    var file = fileInput.files[0];
    if (!file) {
      showError('Ανέβασε το screenshot του τραγουδιού πριν συνεχίσεις.');
      fileInput.focus();
      return;
    }
    if (state.backEnabled && !state.backType) {
      showError('Διάλεξε κείμενο ή φωτογραφία για την επιπλέον χάραξη.');
      return;
    }
    var backTextVal = beText.value.trim();
    if (state.backEnabled && state.backType === 'text' && !backTextVal) {
      showError('Γράψε το κείμενο για την επιπλέον χάραξη.');
      beText.focus();
      return;
    }
    var backFile = beFile.files[0];
    if (state.backEnabled && state.backType === 'photo' && !backFile) {
      showError('Ανέβασε φωτογραφία για την επιπλέον χάραξη.');
      return;
    }

    submitBtn.disabled = true;
    submitBtn.textContent = 'Προσθήκη...';

    var formData = new FormData();
    formData.append('id', getCurrentVariantId());
    formData.append('quantity', 1);
    formData.append('properties[Στιγμιότυπο Spotify]', file);
    formData.append('properties[Πλευρά Spotify Code]', state.mainSide);

    var sizeActive = document.querySelector('[data-pz-pills="size"] .is-active');
    if (sizeActive) formData.append('properties[Επιλογή Μεγέθους]', sizeActive.dataset.value);

    if (state.backEnabled && state.backType === 'text') {
      formData.append('properties[Επιπλέον Χάραξη - Κείμενο]', backTextVal);
      formData.append('properties[Επιπλέον Χάραξη - Γραμματοσειρά]', state.backFont);
    }
    if (state.backEnabled && state.backType === 'photo') {
      formData.append('properties[Επιπλέον Χάραξη - Φωτογραφία]', backFile);
    }

    var notesVal = root.querySelector('[data-pz-field="notes"]').value.trim();
    if (notesVal) formData.append('properties[Παρατηρήσεις - Σχόλια]', notesVal);

    fetch('/cart/add.js', { method: 'POST', body: formData })
      .then(function (r) {
        if (!r.ok) throw new Error('cart-add-failed');
        return r.json();
      })
      .then(function () {
        var addonItems = [];
        if (state.priority) addonItems.push({ id: addons.priority.id, quantity: 1 });
        if (state.review) addonItems.push({ id: addons.review.id, quantity: 1 });
        if (state.note) addonItems.push({ id: addons.note.id, quantity: 1 });
        if (state.backEnabled && state.backType === 'text') addonItems.push({ id: addons.innerText.id, quantity: 1 });
        if (state.backEnabled && state.backType === 'photo') addonItems.push({ id: addons.innerPhoto.id, quantity: 1 });
        if (addonItems.length === 0) return null;
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: addonItems })
        }).then(function (r) {
          if (!r.ok) throw new Error('addon-add-failed');
          return r.json();
        });
      })
      .then(function () {
        window.location.href = '/cart';
      })
      .catch(function () {
        showError('Κάτι πήγε στραβά. Δοκίμασε ξανά.');
        submitBtn.disabled = false;
        submitBtn.textContent = 'Προσθήκη στο Καλάθι';
      });
  });

  window.addEventListener('pageshow', function (e) {
    if (e.persisted) {
      submitBtn.disabled = false;
      submitBtn.textContent = 'Προσθήκη στο Καλάθι';
      errorEl.hidden = true;
    }
  });

  updateTotal();
})();
